<template>
<div id="Loading">
  <div class="loader-inner ball-clip-rotate-multiple">
    <div></div>
    <div></div>
  </div>
  <div class="loading-tip">{{ tips }}</div>
</div>
</template>

<script>
export default {
  props: {
    tips: {
      type: String,
      default: '当前网络环境不佳，正在重连中...',
    },
  },
}
</script>

<style lang="scss" scoped>
#Loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999999;
  background: rgba(0, 0, 0, .5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .loading-tip {
    color: #FFB86D;
    margin-top: 50px;
    font-size: 12px;
  }
  .ball-clip-rotate-multiple {
    position: relative;
  }
  .ball-clip-rotate-multiple>div {
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    position: absolute;
    left: -20px;
    top: -20px;
    border: 2px solid #FFB86D;
    border-bottom-color: transparent;
    border-top-color: transparent;
    border-radius: 100%;
    height: 35px;
    width: 35px;
    -webkit-animation: rotate 1s 0s ease-in-out infinite;
    animation: rotate 1s 0s ease-in-out infinite;
  }
  .ball-clip-rotate-multiple>div:last-child {
    display: inline-block;
    top: -10px;
    left: -10px;
    width: 15px;
    height: 15px;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    border-color: #FFB86D transparent #FFB86D transparent;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }
  @-webkit-keyframes ball-scale-ripple {
    0% {
      -webkit-transform: scale(0.1);
      transform: scale(0.1);
      opacity: 1;
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 0.7;
    }
    100% {
      opacity: 0.0;
    }
  }
  @keyframes ball-scale-ripple {
    0% {
      -webkit-transform: scale(0.1);
      transform: scale(0.1);
      opacity: 1;
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 0.7;
    }
    100% {
      opacity: 0.0;
    }
  }
  .ball-scale-ripple>div {
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    height: 50px;
    width: 50px;
    border-radius: 100%;
    border: 2px solid #FFB86D;
    -webkit-animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
    animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
  }
  @-webkit-keyframes ball-scale-ripple-multiple {
    0% {
      -webkit-transform: scale(0.1);
      transform: scale(0.1);
      opacity: 1;
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 0.7;
    }
    100% {
      opacity: 0.0;
    }
  }
  @keyframes ball-scale-ripple-multiple {
    0% {
      -webkit-transform: scale(0.1);
      transform: scale(0.1);
      opacity: 1;
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 0.7;
    }
    100% {
      opacity: 0.0;
    }
  }
  @-webkit-keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
